module.exports = __webpack_public_path__ + "static/media/search.ae48f4b3.svg";